/**
 * MEDIEVAL_ARCHETYPE
 *
 * The "Ground Truth" statistical profile for Medieval / Ancient music.
 * Traits:
 * - Modal Harmony (Dorian, Mixolydian)
 * - Open Consonance (Perfect 5ths, 4ths, Octaves) - Avoids 3rds in final cadences.
 * - Drone / Pedal Points
 * - Rhythmic Simplicity (Compound time or Free time)
 */

import { SLOW_ARCHETYPE } from './BaseArchetype.js';

export const MEDIEVAL_ARCHETYPE = {
    ...SLOW_ARCHETYPE,

    // Harmonic Rhythm: Static to Moderate.
    // Drones hold for long periods, but melodic motion can be active.
    harmonicRhythm: {
        ...SLOW_ARCHETYPE.harmonicRhythm,
        target: 4.0, // Slow functional change (Drone based)
        tolerance: 2.0
    },

    // Voice Distribution: "Hollow".
    // Bass (Drone) + Mid/High (Melody).
    // Less dense in the mid-low range compared to Romantic.
    voiceDistribution: {
        ...SLOW_ARCHETYPE.voiceDistribution,
        low: 0.30,
        mid: 0.30,
        high: 0.40, // Melodic focus (Flutes, Recorders, Lutes)
        tolerance: 0.20
    },

    // Dynamic Range: Moderate / Flat.
    // Early music instruments have limited dynamic range.
    dynamicRange: {
        ...SLOW_ARCHETYPE.dynamicRange,
        minVariance: 0.10,
        targetVariance: 0.20,
        dynamicShape: 'terraced'
    },

    // Interval Entropy: Stepwise.
    // Vocal-led writing implies smooth lines.
    intervalEntropy: {
        ...SLOW_ARCHETYPE.intervalEntropy,
        stepRatio: 0.70, // High stepwise motion
        tolerance: 0.15
    },

    // Harmonic Consonance: Open Intervals.
    // Standard Consonance metric penalizes "Empty" chords? No, standard physics prefers 5ths.
    // We want highly consonant (perfect intervals).
    harmonicConsonance: {
        ...SLOW_ARCHETYPE.harmonicConsonance,
        polarity: 'consonant',
        weight: 0.3 // High importance
    }
};
